import React, { FC, useState } from 'react'
import { Well } from '@pushly/aqe/lib/components'
import { NotificationScheduleService } from '../../../services/notification-schedule'
import { Col, Form, Input, Row } from 'antd'
import { useService } from '@pushly/aqe/lib/hooks'
import { useForm } from 'antd/es/form/Form'
import { GetNotificationScheduleResponse } from '@pushly/models/lib/structs/notifications'

interface IProps {
    getEntity: () => GetNotificationScheduleResponse
    onSubmit: () => void
    onCancel: () => void
}

export const AdditionalDetailsDataForm: FC<IProps> = ({ getEntity, onSubmit, onCancel }) => {
    const scheduleService = useService(NotificationScheduleService)
    const [form] = useForm()

    const schedule = getEntity()
    const [details, setDetails] = useState<string | undefined>(schedule.additional_details ?? undefined)

    const updateDetailsState = (ev: React.ChangeEvent<HTMLTextAreaElement>) => {
        const value = ev.target.value
        setDetails(value)
        form.setFieldsValue({ details: value })
    }

    const clearDetails = () => {
        setDetails(undefined)
        form.setFieldsValue({ details: undefined })
    }

    const handleSubmit = async () => {
        try {
            await scheduleService.setScheduleDetails(schedule, !details ? null : details)

            getEntity().additional_details = details!
            onSubmit()
        } catch {}
    }

    if (!schedule) {
        return <></>
    }

    return (
        <>
            <Row gutter={16}>
                <Col span={6}>
                    <b>Notification ID:</b>
                </Col>
                <Col span={18}>{schedule.notification_id}</Col>
            </Row>
            <Row gutter={16}>
                <Col span={6}>
                    <b>Schedule ID:</b>
                </Col>
                <Col span={18}>{schedule.id}</Col>
            </Row>
            <Row gutter={16}>
                <Col span={6}>
                    <b>Title:</b>
                </Col>
                <Col span={18}>{schedule.template?.channels?.default?.title}</Col>
            </Row>

            <hr />

            <Well
                className="additional-details-well thin"
                mode="ghost"
                title="Additional Details"
                onSubmit={handleSubmit}
                onCancel={onCancel}
            >
                <Form form={form} initialValues={{ details }}>
                    <div className="fx-row">
                        <div className="fx-col">Add additional notification details to display to the publisher.</div>
                        <div className="fx-col fx-shrink">
                            <a onClick={clearDetails}>
                                <span>Clear</span>
                            </a>
                        </div>
                    </div>

                    <Form.Item name="details">
                        <Input.TextArea onChange={updateDetailsState} value={details} />
                    </Form.Item>
                </Form>
            </Well>
        </>
    )
}
